// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__QyHIc","rootCenter":"LoadMoreObserver_rootCenter__36jGx","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__A6Xby"};